/**
 * Web Style Import
 *
 */

import './style/dnb-tabs.scss'
